/* eslint-disable dot-notation */
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { Popover, Select } from 'antd';
import H3Text from '@Uilib/h3Text';
import ReportActions from '@Actions/reportActions';
import Helpers from '@Apis/helpers';
import H3DateSelector from '@Uilib/h3DateSelector';
import './style.scss';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';

import SelectDepartment from '@Components/Common/SelectDepartment';
import TenantSelector from '../../../Common/Selector/TenantSelector';
import DownloadReports from '../../ReportsHeader/DownloadReports';
import CategoryFilterNew from '../../../Common/CategoryFilterNew';

const { Option } = Select;

/**
 *
 */
function ProductionReportHeader({
  startDate, endDate, selectedTenant, department, selectedMoType, user, selectedCategory, setSelectedCategory,
  setStartDate, setEndDate, setSelectedTenant, setDepartment, setSelectedMoType, setCurrentPage,
  getDownloadReports, type, getDownloadReportsLoading, selectedDepartment, productionReportData,
}) {
  const [openPopover, setOpenPopover] = React.useState(false);
  const [selectedEmails, setSelectedEmails] = React.useState([user.username]);

  /**
   *
   * @param {*} startDate
   * @param {*} endDate
   */
  function loadReportsDownloadData(operationType, required) {
    let limit = 100;

    if (type === 'stock_inward_report' || type === 'stock_outward_report') {
      limit = 10;
    }

    if (!getDownloadReportsLoading) {
      getDownloadReports('manufacturing', '', '', selectedTenant || user?.tenant_info?.tenant_id, startDate, endDate, operationType, 'mo_report', '', selectedDepartment, selectedMoType, '', selectedEmails.join(','), required, '', '', '', '', '', '', selectedCategory);
      setOpenPopover(false);
    }
  }

  // taking the moType from the url
  const url = window.location.href;
  const path = url.split('?')[0]; // Extract path before the query string
  const parts = path.split('/'); // Split the path into parts
  const firstKey = parts[parts.length - 1];

  setSelectedMoType(firstKey === 'fg_report' ? 'FINISHED_GOODS' : 'RAW_MATERIAL');

  return (
    <Fragment>
      <div className="page-header__right report-header__wrapper" style={{ width: '100%', padding: '0px', paddingBottom: '1rem' }}>
        <div className="report-header__heading">
          {firstKey === 'fg_report' ? 'FG Production Report' : 'RM Production Report'}
        </div>
        <div className="report-header__action-container">
          { productionReportData?.production?.length > 0
          && (
            <DownloadReports
              getDownloadReportsLoading={getDownloadReportsLoading}
              loadReportsDownloadData={(operationType, required) => loadReportsDownloadData(operationType, required)}
              selectedEmails={selectedEmails}
              selectedEmailsChange={(event) => setSelectedEmails(event)}
              user={user}
              openPopover={openPopover}
              openPopoverChange={() => setOpenPopover(!openPopover)}
            />
          )}
          <div className="report-header__date-picker">
            <H3DateSelector
              startDate={startDate}
              endDate={endDate}
              onDateChange={(date) => {
                setStartDate(dayjs(date[0])?.valueOf());
                setEndDate(dayjs(date[1])?.valueOf());
              }}
            />
          </div>
          <React.Fragment>
            <div className="report-header__tenant-selector">
              <CategoryFilterNew
                onChange={(value) => {
                  setSelectedCategory(value);
                }}
                selectedCategory={selectedCategory}
                hideTitle
                style={{
                  borderRadius: '4px',
                  width: '150px',
                }}
                placeholder="Select category.."
              />
            </div>
          </React.Fragment>
          <React.Fragment>
            <div className="report-header__tenant-selector">
              <TenantSelector
                selectedTenant={selectedTenant}
                isMultiple
                showSearch
                showAll={false}
                noDropdownAlign
                onChange={(value) => {
                  if (value === 'All') {
                    setCurrentPage(1);
                    setSelectedTenant(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ));
                  } else {
                    setCurrentPage(1);
                    setSelectedTenant(value);
                  }
                }}
                placeholder="Select Business Unit"
                inputClassName="orgInputContainer"
                customStyle={{
                  borderRadius: '4px',
                  width: '300px',
                  fontSize: '13px',
                  marginRight: '10px',
                  paddingTop: '2.5px',
                  marginBottom: '0px',
                }}
                hideTitle
                includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ)}
              />
            </div>
          </React.Fragment>
          <div className="report-header__dept-selector">
            <SelectDepartment
              title="Select Department"
              hideTitle
              selectedDepartment={department}
              noDropdownAlign
              onChange={(value) => {
                setDepartment(value?.department_id || '');
                setCurrentPage(1);
              }}
              customStyle={{
                borderRadius: '4px',
                width: '150px',
                fontSize: '13px',
                marginRight: '10px',
                paddingTop: '2.5px',
              }}
              disabled={false}
            />
          </div>

          {/* <div className="report-header__dept-selector">
            <Select
              value={selectedMoType}
              placeholder="Select Type"
              bordered={false}
              style={{
                borderRadius: '4px',
                width: '150px',
                fontSize: '13px',
                marginRight: '10px',
                marginBottom: '0px',
              }}
              onChange={(value) => {
                setSelectedMoType(value);
              }}
            >
              <Option key={1} label="Finished Goods" value="FINISHED_GOODS">Finished Goods</Option>
              <Option key={2} label="Raw Material" value="RAW_MATERIAL">Raw Material</Option>
            </Select>
          </div> */}

        </div>
      </div>
    </Fragment>
  );
}
const mapStateToProps = ({ ReportReducers, UserReducers }) => ({
  getDownloadReportsLoading: ReportReducers.getDownloadReportsLoading,
  user: UserReducers.user,
  getReportsLoading: ReportReducers.getReportsLoading,
  productionReportData: ReportReducers.productionReportData,
});

const mapDispatchToProps = (dispatch) => ({
  getDownloadReports: (firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails, noWait, intervals, noOfColumns, selectedMethod, selectedDate, costingMethod, customerId, category) => dispatch(
    ReportActions.getDownloadReports(firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails, noWait, intervals, noOfColumns, selectedMethod, selectedDate, costingMethod, customerId, category),
  ),
  getReports: (firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, reportType, page, limit, departmentId) => dispatch(ReportActions.getReports(firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, reportType, page, limit, departmentId)),

});
ProductionReportHeader.propTypes = {
  setStartDate: PropTypes.func,
  setEndDate: PropTypes.func,
  setSelectedTenant: PropTypes.func,
  setDepartment: PropTypes.func,
  setSelectedMoType: PropTypes.func,
  setCurrentPage: PropTypes.func,
  user: PropTypes.object,
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  selectedTenant: PropTypes.any,
  department: PropTypes.any,
  selectedMoType: PropTypes.any,
  getDownloadReportsLoading: PropTypes.bool,
  getDownloadReports: PropTypes.func,
  type: PropTypes.string,
  selectedDepartment: PropTypes.any,
  productionReportData: PropTypes.any,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductionReportHeader));
